export default "__VITE_ASSET__BmCw_q5l__"